<template>
  <div class="p-fluid">
    <div class="p-col-12 p-lg-12">
      <div class="card card-w-title">
        <div class="manager-title">{{ title }}</div>
        <formEdit
          :key="componentKey"
          :mode="mode"
          @back="backToList"
          @save="saveData"
          :model="models"/>
      </div>
    </div>
  </div>
</template>

<script>

import DataServices from '@/core/DataServices'
import formEdit from './add'
export default {
  components: {
    formEdit
  },
  data() {
    return {
      categories: null,
      users: null,
      validationErrors: [],
      title: "Create new stadium",
      mode: 'add',
      models: {},
      componentKey: 0,
      accountID: ''
    }
  },
  async mounted () {
    this.mode = this.$route.name === 'editStadium' ? 'edit' : this.mode;
    this.title = this.mode === 'edit' ? 'Edit stadium' : this.title;
    
    if (this.$route.params.id !== undefined) await this.getData(this.$route.params.id);
    // await this.userLogin();
    //check quyền
    var arr_role = await this.$CoreService.checkPermission(this.$constants.KEY_MENU.LIST_STADIUM);
    if (this.mode == 'edit'){
      if (arr_role.indexOf(this.$constants.ROLE.EDIT) < 0){
        this.$router.push({path: this.$constants.URL_ERR.FOBIDDEN});
      }
    }else {
      if (arr_role.indexOf(this.$constants.ROLE.ADD) < 0){
        this.$router.push({path: this.$constants.URL_ERR.FOBIDDEN});
      }
    }
  },
  methods: {
    backToList() {
      this.$router.push({ path: '/admin/list-stadium' });
    },
    async saveData(params) {
      // console.log("params",params)
      this.images = (params.images !== undefined && params.images !== null) ? params.images : [];
      var that = this;
      var objects = {
        name : params.name,
        plain_name: this.$commonFuction.SkipVN(params.name),
        street : params.street,
        plain_street: this.$commonFuction.SkipVN(params.street),
        active : params.active,
        country_id : params.country_id,
        province_id : params.province_id,
        district_id : params.district_id,
        ward_id : params.ward_id,
        latitude : params.latitude,
        longtitude : params.longtitude,
        address_google : params.address_google,
        plain_address_google : this.$commonFuction.SkipVN(params.address_google),
      }
      if(this.mode == 'add'){
        
        await this.$apollo.mutate({
          mutation: DataServices.insertData('stadium'),
          variables: {
            'objects': objects
          }
        }).then( () => {
          that.redirectEdit();
        })
      }else{
        let variables = {
          'data_update': objects,
          'where_key': {
            'id': {'_eq': this.models.id}
          }
        }
        await this.$apollo.mutate({
          mutation: DataServices.updateData('stadium'),
          variables: variables
        }).then(async (res) => {
          // console.log("res",res);
          if (res.data[Object.keys(res.data)].affected_rows) {
            that.redirectEdit();
            return false;
          }
        })
      }
    },

    async userLogin() {
      var user = this.$store.getters.user;
      var {data} = await this.$apollo.query({
        query: DataServices.getList('accounts', {"fields" : "uid"}),
        variables: {
          where_key: {
            id: {'_eq': user}
          }
        },
        fetchPolicy: "network-only"
      });
      if (data && data[Object.keys(data)] !== undefined && data[Object.keys(data)].length > 0) {
        this.accountID = data[Object.keys(data)][0].uid;
      }
    },
    async redirectEdit() {
      var that = this;
      that.$commonFuction.is_loading(false);
      var router_back = {path: '/admin/list-stadium'};
      // if (!that.$commonFuction.isEmpty(router_back)){
      //   // that.page_transaction = ""+that.page_transaction
      //   router_back.query = { page_transaction: that.page_transaction.toString() };
      // }
      that.$router.push(router_back);
      that.$toast.add({ severity: 'success', summary: 'Notification', detail: 'Save success', life: 3000 })
    },
    async getData(id) {
      var {data} = await this.$apollo.query({
        query: DataServices.getList('stadium',{"fields" : "id name active country_id province_id district_id ward_id latitude longtitude street"}),
        variables: {
          where_key: {
            id: {'_eq': id}
          }
        },
        fetchPolicy: "network-only"
      })
      var model = data[Object.keys(data)];
      if (model.length > 0) {
        this.models = model[0];
      }
      this.componentKey++;
    },
    async getCategories() {
      var {data} = await this.$apollo.query({
        query: DataServices.getList('category', {"fields" : "id name"}),
        fetchPolicy: "network-only"
      })
      this.categories = data[Object.keys(data)];
    }
  },
  apollo: {
    
  }
}
</script>

<style lang="scss">
.p-inputnumber-buttons-stacked {
  .p-inputnumber-button-group {
    .p-button.p-button-icon-only { padding: 0 !important; }
  }
}
.note{ letter-spacing: 0px; color: #707070; margin-bottom: 24px; padding-top: 10px;}
.p-formgrid { margin: 0;
  .p-panel-header {color: #000000; font-size: 18px; font-weight: bold; background: #EEEEEE;}
  .p-card-field{ padding: 24px;
    .p-field{
      .p-col-fixed { width: 300px; display: inline-block !important; margin: 0;}
      .p-col-width{width:450px !important; border-radius: 5px;
        &.disabled{background: #EEEEEE; border: 0 none; padding: 8px 10px;}
        .file-select{margin: 0;
          input[type="file"]{display: none;}
          .select-button{display: inline-block; cursor: pointer; background: transparent; border-radius: 5px;  color: #000000; font-size: 13px; padding: 3px 16px;  border: 1px solid #B4B4B4;}
        }
        &.pac-target-input{ height: 80px;  word-break: break-all; overflow-wrap: break-word;  resize: none;}
      }
      .box-images{ margin: 0; margin-top: 10px; position: relative;
        .item-img{width: 133px; height: 150px;  margin-right: 8px; margin-bottom: 8px; display: inline-flex; position: relative;
          img{max-width: 100%; height: auto;margin: 0 auto; object-fit: contain; padding: 5px;}
          .button-clear{border-radius: 5px; width: 24px; height: 24px; background: #F5564E; float: right; cursor: pointer; position: absolute; right: 0px;
            img{vertical-align: top;}
          }
        }
      }
      .p-invalid{display: block;}
    }
  }
  .fixed-bottom-toolbar{background: transparent; border: 0 none; margin-top: 22px; border-top: 1px solid #B4B4B4; padding: 0; padding-top: 30px;
    .p-button{width: auto; margin-right: 8px;
      &:last-child{margin-right: 0;}
    }
  }
}
.p-field{
  margin-bottom: 0.5rem!important;
}
</style>